import { HStack, Tag } from "@chakra-ui/react";

export interface TagProps {
  tags?: Array<string>;
}
export const Tags = (props: TagProps) => {
  const { tags } = props;
  return (
    <HStack gap={2} wrap="wrap">
      {tags &&
        tags.map((tag) => (
          <Tag
            colorScheme="gray"
            variant="subtle"
            style={{ direction: "rtl" }}
            data-testid="card-FooterTag"
          >
            {tag}
          </Tag>
        ))}
    </HStack>
  );
};
